











































































































































































































































































































































































































































































































































import { Component, Mixins, Watch } from "vue-property-decorator";
import Api from "@/api";
import FormErrorsMixin from "@/mixins/FormErrors";
import swal from "sweetalert";

import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import "vue2-datepicker/locale/de";

import ViewLoader from "@/components/Common/ViewLoader.vue";
import AlertBox from "@/components/Common/Alerts/AlertBox.vue";
import TextInput from "@/components/Common/Inputs/TextInput.vue";
import InfoButton from "@/components/Common/Buttons/InfoButton.vue";
import NavigationTabs from "@/components/Settings/Venue/NavigationTabs.vue";
import Error404 from "@/components/Common/Error404.vue";
import {
  ICountry,
  ICountryState,
  IFacility,
  IOpeningTime,
  IVenue
} from "@/interface";
import { AxiosResponse } from "axios";

interface IWeekDay {
  id: number;
  abbr: string;
  name: string;
  checked: boolean;
  starts_at: Date | string | null;
  ends_at: Date | string | null;
}

Component.registerHooks(["beforeRouteEnter", "beforeRouteUpdate"]);

@Component({
  components: {
    ViewLoader,
    AlertBox,
    TextInput,
    DatePicker,
    InfoButton,
    NavigationTabs,
    Error404
  }
})
export default class VenueGeneralSettings extends Mixins(FormErrorsMixin) {
  public loading = false;
  public updating = false;
  public validatedInputs = [
    "name",
    "short_name",
    "description",
    "address.country_id",
    "address.state_id",
    "address.city",
    "address.post_code",
    "address.street_name",
    "address.street_number",
    "address.additional_information"
  ];
  private facilities: Array<IFacility> = [];
  private space = "\xa0";
  private noDataExist = false;
  private countries: Array<ICountry> = [];
  private selectedVenue: IVenue | null = null;
  private selectedVenueId: string | null = null;
  private starts_at: Date | string | null = null;
  private ends_at: Date | string | null = null;
  private timeFormat = "HH:mm";
  private isDiffDays = false;
  private isOpeningTimeIdentical = false;
  private isAddressIdentical = false;
  private weekdays: Array<IWeekDay> = [
    {
      id: 0,
      abbr: "MO",
      name: "monday",
      checked: false,
      starts_at: null,
      ends_at: null
    },
    {
      id: 1,
      abbr: "TU",
      name: "tuesday",
      checked: false,
      starts_at: null,
      ends_at: null
    },
    {
      id: 2,
      abbr: "WE",
      name: "wednesday",
      checked: false,
      starts_at: null,
      ends_at: null
    },
    {
      id: 3,
      abbr: "TH",
      name: "thursday",
      checked: false,
      starts_at: null,
      ends_at: null
    },
    {
      id: 4,
      abbr: "FR",
      name: "friday",
      checked: false,
      starts_at: null,
      ends_at: null
    },
    {
      id: 5,
      abbr: "SA",
      name: "saturday",
      checked: false,
      starts_at: null,
      ends_at: null
    },
    {
      id: 6,
      abbr: "SU",
      name: "sunday",
      checked: false,
      starts_at: null,
      ends_at: null
    }
  ];

  private beforeRouteEnter(to: any, from: any, next: any): void {
    next((vm: this) => {
      vm.selectedVenueId = vm.$route.params.id;
      vm.getFacilities(() => {
        if (
          vm.selectedVenueId !== null &&
          vm.selectedVenueId !== undefined &&
          vm.selectedVenueId !== "default"
        ) {
          vm.getVenue(() => {
            vm.getCountries(() => {
              //
            });
          });
        }
      });
    });
  }

  private beforeRouteUpdate(to: any, from: any, next: any): void {
    this.getFacilities(() => {
      if (this.selectedVenueId && this.selectedVenueId !== "default") {
        this.getVenue(() => {
          this.getCountries(() => {
            //
          });
        });
      }
    });
    next();
  }

  private toggleCheckbox(id: number): void {
    this.weekdays[id].checked = !this.weekdays[id].checked;
    if (this.starts_at) {
      this.weekdays[id].starts_at = this.starts_at;
    }
    if (this.ends_at) {
      this.weekdays[id].ends_at = this.ends_at;
    }
  }

  private getFacilities(successCallback?: any): void {
    this.loading = true;
    const endpoint = this.$partnerEndpoint("facilities/simplified");

    Api()
      .get(endpoint)
      .then((response: AxiosResponse) => {
        this.facilities = response.data.data;
        if (!this.selectedVenueId || this.selectedVenueId === "default") {
          const selectedFacility = this.facilities.find(
            (facility: IFacility) =>
              facility.venues && facility.venues.length > 0
          );
          if (
            selectedFacility &&
            selectedFacility.venues &&
            selectedFacility.venues[0].id
          ) {
            this.selectedVenueId = `${selectedFacility.venues[0].id}`;
          }
        }
        if (typeof successCallback == "function") {
          successCallback();
        }
      })
      .catch((error: any) => {
        console.log(error);
      });
  }

  private getVenue(successCallback?: any): void {
    this.loading = true;
    const endpoint: string = this.$partnerEndpoint(
      "venues/" + this.selectedVenueId
    );

    Api()
      .get(endpoint)
      .then((response: AxiosResponse) => {
        this.selectedVenue = (response.data.data || {}) as IVenue;
        if (!this.selectedVenue.address) {
          this.selectedVenue.address = {
            additional_information: null,
            city: null,
            country_id: null,
            post_code: null,
            state_id: null,
            street_name: null,
            street_number: null
          };
        }
        this.weekdays = this.weekdays.map(weekday => ({
          ...weekday,
          checked: false,
          starts_at: null,
          ends_at: null
        }));
        if (this.selectedVenue.opening_times) {
          this.selectedVenue.opening_times.map(
            (time: IOpeningTime, index: number) => {
              if (index === 0) {
                this.isDiffDays = false;
                if (time.open_time) {
                  this.starts_at = time.open_time;
                  this.weekdays[(time.day as number) - 1].starts_at =
                    time.open_time;
                }
                if (time.close_time) {
                  this.ends_at = time.close_time;
                  this.weekdays[(time.day as number) - 1].ends_at =
                    time.close_time;
                }
                this.weekdays[(time.day as number) - 1].checked = true;
              }
              if (
                this.starts_at !== time.open_time ||
                this.ends_at !== time.close_time
              ) {
                this.isDiffDays = true;
                this.starts_at = null;
                this.ends_at = null;
              }
            }
          );
        }
        if (this.selectedVenue.use_facility_opening_times) {
          this.isOpeningTimeIdentical = this.selectedVenue.use_facility_opening_times;
        }
        if (this.selectedVenue.use_facility_address) {
          this.isAddressIdentical = this.selectedVenue.use_facility_address;
        }
        if (typeof successCallback == "function") {
          successCallback();
        }
      })
      .catch((error: any) => {
        if (error.response.status === 404) {
          this.noDataExist = true;
        }
        console.log(error.response);
      })
      .finally(() => {
        this.loading = false;
      });
  }

  private updateVenue(): void {
    if (this.loading || this.updating) {
      return;
    }
    this.resetErrors();
    this.updating = true;
    const endpoint: string = this.$partnerEndpoint(
      "venues/" + this.selectedVenueId
    );
    if (this.selectedVenue) {
      this.selectedVenue.opening_times = this.weekdays
        .filter(
          weekday => weekday.starts_at && weekday.ends_at && weekday.checked
        )
        .map(weekday => ({
          day: weekday.id + 1,
          times: [
            {
              open_time: weekday.starts_at,
              close_time: weekday.ends_at
            }
          ]
        }));
      this.selectedVenue.use_facility_opening_times = this.isOpeningTimeIdentical;
      this.selectedVenue.use_facility_address = this.isAddressIdentical;
    }
    Api()
      .put(endpoint, this.selectedVenue)
      .then(() => {
        this.getFacilities(() => {
          this.getVenue(() => {
            swal({
              title: "Success!",
              text: "The venue was updated.",
              icon: "success"
            });
          });
        });
      })
      .catch((error: any) => {
        this.storeErrors(error.response.data.errors);
        this.$scrollTo("#venue-email", 500);
      })
      .finally(() => {
        this.updating = false;
      });
  }

  private getCountries(successCallback?: any): void {
    Api()
      .get("api/internal/v1/countries")
      .then((response: AxiosResponse) => {
        this.countries = response.data.data;

        if (typeof successCallback == "function") {
          successCallback();
        }
      })
      .catch((error: any) => {
        console.log(error);
      });
  }

  private countryShouldBeSelected(country: ICountry): boolean {
    return (
      this.selectedVenue !== null &&
      this.selectedVenue.address !== undefined &&
      this.selectedVenue.address.country_id == country.id
    );
  }

  private stateShouldBeSelected(state: ICountryState): boolean {
    return (
      this.selectedVenue !== null &&
      this.selectedVenue.address !== undefined &&
      this.selectedVenue.address.state_id == state.id
    );
  }

  get venueName(): string {
    return (this.selectedVenue !== null && this.selectedVenue.name) || "";
  }

  get statesOfSelectedCountry(): Array<ICountryState> {
    for (var i = 0; i < this.countries.length; i++) {
      if (
        this.selectedVenue !== null &&
        this.selectedVenue.address !== undefined &&
        this.countries[i].id != this.selectedVenue.address.country_id
      ) {
        continue;
      }
      return this.countries[i].states || [];
    }

    return [];
  }

  @Watch("selectedVenueId")
  selectedVenueIdChanged(selectedVenueId: number): void {
    this.$router.push({
      name: "VenueGeneralSettings",
      params: { id: `${selectedVenueId}` }
    });
  }

  @Watch("starts_at")
  starts_at_changed(starts_at: Date | string | null): void {
    if (!this.isDiffDays) {
      this.weekdays.map(weekday => {
        if (weekday.checked) {
          weekday.starts_at = starts_at;
        }
      });
    }
  }

  @Watch("ends_at")
  ends_at_changed(ends_at: Date | string | null): void {
    if (!this.isDiffDays) {
      this.weekdays.map(weekday => {
        if (weekday.checked) {
          weekday.ends_at = ends_at;
        }
      });
    }
  }
}
